/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//服务
const serverLayout = require('src/appBackend/components/page/server/server-layout/server-layout');
const serverList = require('src/appBackend/components/page/server/server-list/server-list');
const serverSet = require('src/appBackend/components/page/server/server-set/server-set');

module.exports = {
  "component": serverLayout,
  "subRoutes": {
    "/official-list": {
      "component": serverLayout,
      subRoutes:{
        "/":{
          "title": "官方服务列表",
          "component": serverList,
          "official": true,
        },
        "/add":{
          "component":serverSet,
          "name":"官方服务新增",
          "title": "官方服务新增",
          "official": true
        },
        "/edit":{
          "component":serverSet,
          "name": "官方服务编辑",
          "title":"官方服务编辑",
          "official": true
        }
      }
    },
    "/third-party-list": {
      "component": serverLayout,
      subRoutes:{
        "/":{
          "title": "第三方服务列表",
          "component": serverList,
          "official": false,
        },
        "/add":{
          "component":serverSet,
          "name":"第三方服务新增",
          "title": "第三方服务新增",
          "official": false
        },
        "/edit":{
          "component":serverSet,
          "name": "第三方服务编辑",
          "title":"第三方服务编辑",
          "official": false
        }
      }
    }
  }
}





// WEBPACK FOOTER //
// ./src/appBackend/router/server.js